<template>
  <v-chip
    v-bind="$attrs"
    :class="hideText ? 'px-0 mr-1' : 'pl-0'"
    :color="ticketTypeConfig.color"
    :variant="variant ?? 'tonal'"
    :density="density ?? 'comfortable'"
  >
    <template #prepend>
      <v-avatar :class="hideText ? undefined : 'mr-2'" :size="avatarSize" :color="ticketTypeConfig.color">
        <v-icon :icon="ticketTypeConfig.icon" class="text-white" :size="iconSize" />
      </v-avatar>
    </template>

    <span v-if="!hideText" class="text-high-emphasis">{{ ticketTypeConfig.description }}</span>
  </v-chip>
</template>

<script setup lang="ts">
const props = defineProps<{
  ticketType: TicketType
  hideText?: boolean
  density?: "comfortable" | "compact" | "default"
  variant?: "tonal" | "outlined" | "text" | "flat" | "elevated" | "plain"
}>()
const { ticketType, hideText, density } = toRefs(props)

const $i18n = useI18n()

const ticketTypeConfig = computed(() => {
  switch (ticketType.value) {
    case TicketType.ACTION:
      return {
        description: $i18n.t("actions.action"),
        icon: "$action",
        color: "action",
      }
    case TicketType.MALFUNCTION:
      return {
        description: $i18n.t("malfunctions.malfunction"),
        icon: "$malfunction",
        color: "malfunction",
      }
    case TicketType.NEN3140:
      return {
        description: $i18n.t("nen3140s.nen3140"),
        icon: "$nen3140",
        color: "nen3140",
      }
    case TicketType.NEN1010:
      return {
        description: $i18n.t("nen1010s.nen1010"),
        icon: "$nen1010",
        color: "nen1010",
      }
    case TicketType.INSPECTION:
      return {
        description: $i18n.t("inspections.inspection"),
        icon: "$inspection",
        color: "inspection",
      }
    default:
      console.error(`Unknown ticket type: ${ticketType.value}`)
      return {
        description: $i18n.t("unknown"),
        icon: "question_mark",
        color: "grey",
      }
  }
})

const avatarSize = computed(() => {
  if (density?.value === "compact") return "1.15rem"
  if (density?.value === "comfortable" || !density.value) return "1.75rem"

  return "2rem"
})

const iconSize = computed(() => {
  if (density?.value === "compact") return "1rem"
  if (density?.value === "comfortable" || !density.value) return "1.25rem"

  return "1.5rem"
})
</script>
